import type { FaireProductEntity } from "../../entity_types/product";

export const p_3zd8w34nc4: FaireProductEntity = {
  token: "p_3zd8w34nc4",
  type: "product",
  name: "Palo Santo Candle",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/63a6ce573e3d51dced3c88b5a38b2e13d3cd5ffd8d832781e3d720e44d1c910b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8fcf8c18e01248177f7810b1ab1c3680d0cb4c1bb8c74094ff9f31c792e55513.jpeg",
    "https://cdn.faire.com/fastly/fae2a9669671283c404a424924c81d6f9a7e7204a98a33e05edf888f4368f2d2.jpeg",
  ],
  priceDollars: 16,
  description:
    "dilo candles are hand poured and made using 100% USA grown Soy Wax. \n\nDesigned and poured at dilo Studios in Philadelphia.\n\nTop Notes: Black Pepper - Clove - Bergamot\nHeart: Palo Santo - Lavender\nBase: Patchouli - Amber - Cedarwood\n\n8.5 ounces - Burns 45 Hours\nAll candles are Phthalate-free, using cotton wicks with no lead cores for safer, cleaner burning.\n",
  tags: [],
  msrpDollars: 32,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:01.720Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
